// extracted by mini-css-extract-plugin
export default {"multiSector":"multiSector_multiSector__MFA12"};